import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from '../../../styles/bantrab/components/card.module.scss'

const Body = ({ children, padded, ...attrs }) => {
  const { className } = attrs

  if (className !== null || className !== undefined) {
    delete attrs.className
  }

  const bodyClasses = classNames(className, {
    [styles.body]: true,
    [styles.padded]: padded
  })

  return (
    <div {...attrs} className={bodyClasses}>
      {children}
    </div>
  )
}

Body.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  padded: PropTypes.bool
}

export default Body
